// REACT & REDUX
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

// STYLE, PROPS & TRANSLATIONS
//import { translate } from "react-i18next";

// COMMON

// COMPONENTS
import { Login } from "./Login.component";

// CONTAINERS

// ACTIONS & API

// *************************************************************************************************************************************

const mapStateToProps = state => {
    return {
        user: state.authentication.user,
        errorMessage: state.authentication.authenticationError,
        username: state.authentication.username,
        userFirstName: state.authentication.userFirstName,
        userLastName: state.authentication.userLastName,
        password: state.authentication.userPassword
    };
};

export default withRouter(connect(mapStateToProps)(Login));
